module.exports = __webpack_public_path__ + "img/front.e4a4b936.jpg";